import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Icon } from "../Icon";
import { useAuth } from "../auth";
import { PageHero, useSeo } from "../ui";

export default function Login() {
  useSeo({
    title: "로그인 | I.META 아이닷메타",
    description: "I.META 회원 로그인. 제품 구매와 회원 전용 자료 다운로드에 필요합니다.",
    path: "/login",
  });

  const { login, member } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/";

  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  async function onSubmit(e) {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      await login(form.email.trim(), form.password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  if (member) {
    return (
      <PageHero kicker="LOGIN" title="이미 로그인되어 있습니다" desc={`${member.name} 님으로 로그인 중입니다.`}>
        <div className="hero__actions">
          <Link to="/account" className="btn btn--primary">내 정보</Link>
          <Link to="/" className="btn btn--ghost">홈으로</Link>
        </div>
      </PageHero>
    );
  }

  return (
    <>
      <PageHero kicker="LOGIN" title="로그인" desc="제품 구매와 회원 전용 자료 다운로드에 필요합니다. 아직 회원이 아니시면 아래에서 가입하실 수 있습니다." />

      <section className="section section--tight">
        <form className="auth-card form" onSubmit={onSubmit} noValidate>
          <div className="form__field">
            <label className="form__label" htmlFor="li-email">이메일</label>
            <input
              id="li-email" className="form__input" type="email" required maxLength={200}
              autoComplete="email" value={form.email} onChange={upd("email")} disabled={busy}
            />
          </div>

          <div className="form__field">
            <label className="form__label" htmlFor="li-pw">비밀번호</label>
            <input
              id="li-pw" className="form__input" type="password" required maxLength={200}
              autoComplete="current-password" value={form.password} onChange={upd("password")} disabled={busy}
            />
          </div>

          {error && <p className="form__error" role="alert">{error}</p>}

          <button type="submit" className="btn btn--primary btn--block" disabled={busy}>
            {busy ? "로그인 중…" : "로그인"}
            {!busy && <Icon.ArrowRight width="16" height="16" aria-hidden="true" focusable="false" />}
          </button>

          <p className="form__note">
            비밀번호를 잊으셨나요? <Link to="/password-reset">비밀번호 찾기</Link>
          </p>

          <div className="auth-switch">
            <span className="auth-switch__label">아직 회원이 아니신가요?</span>
            <Link to="/signup" className="btn btn--ghost btn--block">
              회원가입하기
              <Icon.ArrowRight width="16" height="16" aria-hidden="true" focusable="false" />
            </Link>
          </div>
        </form>
      </section>
    </>
  );
}
